export default __webpack_public_path__ + "static/media/social-youtube.771d4785.svg";